import type { ReactNode } from "react"
import React from "react"
import ReactDOM from "react-dom"
import { usePopperTooltip } from "react-popper-tooltip"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { BitsGradientIcon } from "components/shared/icons/bits-gradient-icon"
import { OilsGradientIcon } from "components/shared/icons/oils-gradient-icon"

export function BalancePopup({
  children,
  value,
  frozenValue,
  type = "oils",
}: {
  children: ReactNode
  value: string | number
  frozenValue: string | number
  type: "oils" | "bits"
}) {
  const { isMobile } = useTailwindBreakpoints()
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    trigger: "hover",
    interactive: true,
    offset: type === "oils" ? (isMobile ? [50, 15] : [65, 30]) : isMobile ? [-50, 15] : [-65, 30],
  })
  const style = { "--tooltipBackground": "#3A35A0" } as React.CSSProperties

  return (
    <Box>
      <div ref={setTriggerRef}>{children}</div>

      {visible &&
        ReactDOM.createPortal(
          <div ref={setTooltipRef} {...getTooltipProps({ className: "tooltip-container p-4 text-shadow-none", style })}>
            <Box className="font-semibold text-[#A9A1FF]">Your Balance:</Box>
            <Box row className="h-10 w-[14rem] items-center rounded-md bg-[#000000]/10 font-bold">
              {type === "oils" ? (
                <OilsGradientIcon className="mx-2 h-6 w-6" />
              ) : (
                <BitsGradientIcon className="mx-2 h-6 w-6" />
              )}{" "}
              <Box>{value}</Box>
            </Box>

            <Box className="mt-4 font-semibold text-[#A9A1FF]">Frozen Rewards:</Box>
            <Box row className="h-10 w-[14rem] items-center rounded-md bg-[#000000]/10 font-bold">
              {type === "oils" ? (
                <OilsGradientIcon className="mx-2 h-6 w-6" />
              ) : (
                <BitsGradientIcon className="mx-2 h-6 w-6" />
              )}{" "}
              <Box>{frozenValue}</Box>
            </Box>

            <div {...getArrowProps({ className: "tooltip-arrow", style })} />
          </div>,
          document.body,
        )}
    </Box>
  )
}
